import styles from './radio-group.module.scss';
import MaterialRadioGroup from '@mui/material/RadioGroup';
import { ChangeEvent, ReactNode } from 'react';
import { FormControl, FormLabel } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface RadioGroupProps {
  children: any,
  defaultValue?: any,
  name?: string,
  onChange?: (event: ChangeEvent, value: string) => void,
  value?: any
  // className?: string
  row?: any
  formControlComponent?: any
  formLabelComponent?: any
  title?: string | ReactNode
}

export function RadioGroup(props: RadioGroupProps) {
  return (
    <FormControl
      component={props.formControlComponent}>
      <FormLabel
        component={props.formLabelComponent}>
        {props.title}
      </FormLabel>
      <MaterialRadioGroup
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        row={props.row}
        defaultValue={props.defaultValue}>
        {props.children}
      </MaterialRadioGroup>
    </FormControl>
  );
}

export default RadioGroup;